/** The page a tab shows when no cloud answers its config probe. */
import { RotateCw } from 'lucide-react';
import type { ReactElement } from 'react';
import React from 'react';

import occurraLogo from '@/assets/occurra-logo.svg';
import { Button } from '@/components/occurra/Button';

const PAGE = 'theme-occurra flex h-dvh items-center justify-center bg-occ-background-main' +
    ' text-occ-foreground-main';
const CARD = 'occ-card-surface flex w-full max-w-md flex-col items-center gap-4 p-8' +
    ' text-center';

interface Props {
    onRetry: () => void;
}

export const BootErrorPage = ({ onRetry }: Props): ReactElement => (
    <div className={PAGE}>
        <div className={CARD}>
            <img
                src={occurraLogo}
                alt="Occurra"
                className="size-12 rounded-full object-cover"
            />
            <h1 className="text-xl font-semibold">Cannot reach Occurra Cloud</h1>
            <p className="text-sm text-occ-foreground-tertiary">
                Check the connection, then try again.
            </p>
            <Button
                variant="accent"
                size="medium"
                onClick={onRetry}
            >
                <RotateCw />
                Retry
            </Button>
        </div>
    </div>
);
